import * as React from "react";
import * as Scrivito from "scrivito";
import { getPageLink } from "utils";

interface ImageWidgetProps {
  widget?: Scrivito.Widget;
}

Scrivito.provideComponent("ImageWidget", ({ widget }: ImageWidgetProps) => {
  if (!widget) return null;
  let image = (
    <Scrivito.ImageTag
      content={widget}
      attribute="image"
      alt={alternativeText(widget)}
    />
  );

  const link = widget.get("link") as Scrivito.Link | null;
  if (link && !Scrivito.isInPlaceEditingActive()) {
    image = <Scrivito.LinkTag to={getPageLink(link)}>{image}</Scrivito.LinkTag>;
  }
  return <>{image}</>;
});

function alternativeText(widget: Scrivito.Widget): string {
  const widgetAlternativeText = widget.get("alternativeText") as string;
  if (widgetAlternativeText) {
    return widgetAlternativeText;
  }

  const image = widget.get("image") as Scrivito.Obj | null;
  if (image) {
    return image.get("alternativeText") as string;
  }

  return "";
}
